// extracted by mini-css-extract-plugin
export default {"ModeratorInvitationListItem":"bco_a bhp_a bhp_r bhp_j","ModeratorInvitationListItem__left":"bco_b bhp_a bhp_j","ModeratorInvitationListItem__note":"bco_c bhp_fo"};